import Image_1 from "./Image_1"

export const ProductDetailImage = {
    "Image_1": ({ item }) => { return <Image_1 item={item} /> }
}